export class NumericConverter {
  private units: string[] = [
    "cero",
    "uno",
    "dos",
    "tres",
    "cuatro",
    "cinco",
    "seis",
    "siete",
    "ocho",
    "nueve",
  ];
  private specials: string[] = [
    "diez",
    "once",
    "doce",
    "trece",
    "catorce",
    "quince",
    "dieciséis",
    "diecisiete",
    "dieciocho",
    "diecinueve",
  ];
  private tens: string[] = [
    "",
    "",
    "veinti",
    "treinta",
    "cuarenta",
    "cincuenta",
    "sesenta",
    "setenta",
    "ochenta",
    "noventa",
  ];
  private hundreds: string[] = [
    "",
    "ciento",
    "doscientos",
    "trescientos",
    "cuatrocientos",
    "quinientos",
    "seiscientos",
    "setecientos",
    "ochocientos",
    "novecientos",
  ];

  public convertUnits(num: number): string {
    switch (num) {
      case 1:
        return "UN";
      case 2:
        return "DOS";
      case 3:
        return "TRES";
      case 4:
        return "CUATRO";
      case 5:
        return "CINCO";
      case 6:
        return "SEIS";
      case 7:
        return "SIETE";
      case 8:
        return "OCHO";
      case 9:
        return "NUEVE";
    }
    return "";
  }

  public convertTens(num: number): string {
    const ten = Math.floor(num / 10);
    const unit = num - ten * 10;

    switch (ten) {
      case 1:
        switch (unit) {
          case 0:
            return "DIEZ";
          case 1:
            return "ONCE";
          case 2:
            return "DOCE";
          case 3:
            return "TRECE";
          case 4:
            return "CATORCE";
          case 5:
            return "QUINCE";
          default:
            return "DIECI" + this.convertUnits(unit);
        }
      case 2:
        switch (unit) {
          case 0:
            return "VEINTE";
          default:
            return "VEINTI" + this.convertUnits(unit);
        }
      case 3:
        return this.convertTensY("TREINTA", unit);
      case 4:
        return this.convertTensY("CUARENTA", unit);
      case 5:
        return this.convertTensY("CINCUENTA", unit);
      case 6:
        return this.convertTensY("SESENTA", unit);
      case 7:
        return this.convertTensY("SETENTA", unit);
      case 8:
        return this.convertTensY("OCHENTA", unit);
      case 9:
        return this.convertTensY("NOVENTA", unit);
      case 0:
        return this.convertUnits(unit);
    }
    return "";
  }

  private convertTensY(strSin: string, numUnits: number): string {
    if (numUnits > 0) return strSin + " Y " + this.convertUnits(numUnits);

    return strSin;
  }

  public convertHundreds(num: number): string {
    const hundreds = Math.floor(num / 100);
    const tens = num - hundreds * 100;

    switch (hundreds) {
      case 1:
        if (tens > 0) return "CIENTO " + this.convertTens(tens);
        return "CIEN";
      case 2:
        return "DOSCIENTOS " + this.convertTens(tens);
      case 3:
        return "TRESCIENTOS " + this.convertTens(tens);
      case 4:
        return "CUATROCIENTOS " + this.convertTens(tens);
      case 5:
        return "QUINIENTOS " + this.convertTens(tens);
      case 6:
        return "SEISCIENTOS " + this.convertTens(tens);
      case 7:
        return "SETECIENTOS " + this.convertTens(tens);
      case 8:
        return "OCHOCIENTOS " + this.convertTens(tens);
      case 9:
        return "NOVECIENTOS " + this.convertTens(tens);
    }
    return this.convertTens(tens);
  }

  public convertSection(
    num: number,
    divisor: number,
    strSingular: string,
    strPlural: string
  ): string {
    const hundreds = Math.floor(num / divisor);
    const rest = num - hundreds * divisor;

    let letter = "";

    if (hundreds > 0)
      letter =
        hundreds > 1
          ? this.convertHundreds(hundreds) + " " + strPlural
          : strSingular;

    if (rest > 0) letter += "";

    return letter;
  }

  public convertThousands(num: number): string {
    const divisor = 1000;
    const hundreds = Math.floor(num / divisor);
    const rest = num - hundreds * divisor;

    const strMiles = this.convertSection(num, divisor, "UN MIL", "MIL");
    const strCentenas = this.convertHundreds(rest);

    if (strMiles == "") return strCentenas;

    return strMiles + " " + strCentenas;
  }

  public convertMillions(num: number): string {
    const divisor = 1000000;
    const hundreds = Math.floor(num / divisor);
    const rest = num - hundreds * divisor;

    const strMillions = this.convertSection(
      num,
      divisor,
      "UN MILLON",
      "MILLONES"
    );
    const strThousands = this.convertThousands(rest);

    if (strMillions == "") return strThousands;

    return strMillions + " " + strThousands;
  }

  public numberToWords(num: number): string {
    let letters = "";

    if (num < 0) return "NEGATIVO " + this.numberToWords(Math.abs(num));
    if (num == 0) return "CERO";

    letters += num < 1 ? "CENTAVOS" : this.convertMillions(num);

    return letters;
  }
}
